import React, { useEffect, useState } from "react";
import Layout from "../shared/Layout";
import "../../ComponentsCss/Dashboard.css"; // external CSS
import axiosIns, { API_URL } from "../../_config";
import toast from "react-hot-toast";
import { decryptData } from "../../_seivices";

const Dashboard = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    // Fetch Creative list
    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axiosIns.get(API_URL.GetDashboard);

            // Get the encrypted header
            const encrypted = res?.headers["x-encrypted"];

            // Fallback if header is missing
            if (!encrypted) {
                setData([]);
                return;
            }

            // Attempt to decrypt
            const decrypted = decryptData(encrypted);

            // Validate decrypted data
            if (decrypted && decrypted.isSuccess === 1) {
                setData(decrypted.data);
            } else {
                setData([]);
            }

        } catch (error) {
            toast.error("Error fetching data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Layout>
            {loading ? (
                <p>loading...</p>
            ) : (
                <div className="dashboard-container px-4">

                    {/* Header */}
                    <div className="dashboard-header">
                        <h2 className="dashboard-title">Dashboard</h2>
                        <p className="dashboard-subtitle">Welcome back! Here's an overview of your system.</p>
                    </div>

                    {/* Stats Row */}
                    <div className="row g-4">
                        <div className="col-lg-3 col-sm-6">
                            <div className="dashboard-card">
                                <h3>{data?.totalProjects}</h3>
                                <p>Total Projects</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-sm-6">
                            <div className="dashboard-card">
                                <h3>{data?.totalEnquiry}</h3>
                                <p>Total Enquiry</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-sm-6">
                            <div className="dashboard-card">
                                <h3>{data?.totalPostEnquiry}</h3>
                                <p>Total Job Application</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-sm-6">
                            <div className="dashboard-card">
                                <h3>{data?.totalQuotation}</h3>
                                <p>Total Quotation</p>
                            </div>
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="dashboard-section mt-5">
                        <h4 className="section-title">Recent Activity</h4>

                        <div className="table-responsive">
                            <table className="table dashboard-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>User</th>
                                        <th>Activity</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>Mahesh</td>
                                        <td>Added new project</td>
                                        <td>10 Dec 2025</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Ravi</td>
                                        <td>Updated user details</td>
                                        <td>09 Dec 2025</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Asha</td>
                                        <td>Uploaded file</td>
                                        <td>08 Dec 2025</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Quick Actions */}
                    <div className="dashboard-actions mt-4">
                        <h4 className="section-title">Quick Actions</h4>

                        <div className="row g-4">
                            <div className="col-md-4">
                                <button className="btn dashboard-btn w-100">Add New User</button>
                            </div>
                            <div className="col-md-4">
                                <button className="btn dashboard-btn w-100">Create Project</button>
                            </div>
                            <div className="col-md-4">
                                <button className="btn dashboard-btn w-100">Generate Report</button>
                            </div>
                        </div>
                    </div>

                </div>
            )}
        </Layout>
    );
};

export default Dashboard;
